import React, { Component } from "react";
import { translate } from "../../../utils/useful";
import DropHandles from "./DropHandlers";
import RowContent from "./RowContent";

class SingleRow extends Component {
    state = {
        showRowHandlers: false
    };
    onDrop = (e, rowID, direction, inputIndex) => {
        e.preventDefault();
        let dragData;
        if (e.dataTransfer.getData) {
            dragData = e.dataTransfer.getData("dragData");
        } else {
            dragData = e.dataTransfer;
            dragData = JSON.stringify(dragData);
        }

        //
        const { rowId, dropType, type, inputId } = JSON.parse(dragData);
        let sectionId = this.props.sectionId;

        if (dropType == "NEW") {
            if (!direction) {
                this.props.addnewItem(type, sectionId, rowID);
            }
            if (direction) {
                this.props.addnewItem(
                    type,
                    sectionId,
                    rowID,
                    direction,
                    inputIndex
                );
            }
            this.setState({ showRowHandlers: false });
        }
        if (dropType == "CHANGE") {
            this.props.changeInputPosition(
                inputId,
                sectionId,
                rowId,
                type,
                rowID,
                direction,
                inputIndex
            );
            e.target.style.background = "rgb(168, 160, 160)";
        }
        this.rowRef.style.backgroundColor = "none";
        this.rowRef.style.border = "none";
        this.props.setDisplayHandlers();
    };
    onDragOver = (e, innerLine) => {
        // if(e.target != null) return;
        // console.log("first");
        e.preventDefault();
        this.setState({ showRowHandlers: true }, () => {});
        // if (this.props.rowContent.length == 0) {
        //     this.rowRef.style.border = "1px dahsed #6D79CC";
        //     e.target.style.background = "rgb(245, 240, 240)";

        //     // this.dropText.style.backgroundColor = "red";
        // } else {
        //     innerLine.style.visibility = "hidden";
        //     this.rowRef.style.border = "rgb(245, 240, 240) !important";
        //     e.target.style.background =
        //         "linear-gradient(to left, #6D79CC, #7D89dC )";
        // }
    };

    onDragLeave = (e, innerLine) => {
        this.setState({ showRowHandlers: false }, () => {
            // console.log(this.state.showRowHandlers);
            // if (this.props.rowContent == 0) {
            //     // e.target.style.background = "rgb(245, 240, 240)";
            //     // this.rowRef.style.border = "1px dahsed transparent";

            //     this.dropText.style.backgroundColor = "transparent";
            // } else {
            //     innerLine.style.visibility = "visible";
            //     e.target.style.background = "none";
            // }
        });
    };

    render() {
        const {
            sectionId,
            formsRows,
            rowId,
            rowContent,
            rowLength,
            rowIndex,
            deleteInput,
            openInputConfig
        } = this.props;
        // const { displayHandlers } = this.state;
        const dropHandles = [
            { direction: "top", style: {} },
            { direction: "bottom", style: {} }
        ];

        return (
            <div
                ref={(el) => (this.rowRef = el)}
                key={rowId}
                className="form-row "
                onDragOver={(e) => this.onDragOver(e)}
                onDragLeave={(e) => this.onDragLeave(e)}
            >
                <div
                    className="row"
                    style={{
                        width: "100%",
                        display: "flex",
                        border: "1px solid transparent"
                    }}
                >
                    {rowContent.length > 0 ? (
                        rowContent.map((header, index) => {
                            const { id, type } = header;
                            return (
                                <RowContent
                                    sectionId={sectionId}
                                    inputClass={this.props.inputClass}
                                    formClass={this.props.formClass}
                                    header={header}
                                    openInputConfig={openInputConfig}
                                    index={index}
                                    key={id}
                                    inputId={id}
                                    rowId={rowId}
                                    type={type}
                                    rowLength={rowLength}
                                    onDrop={this.onDrop}
                                    onDragOver={this.onDragOver}
                                    onDragLeave={this.onDragLeave}
                                    deleteInput={deleteInput}
                                />
                            );
                        })
                    ) : (
                        <div
                            onDrop={(e) =>
                                rowContent.length == 0 && this.onDrop(e, rowId)
                            }
                            onDragOver={(e) => this.onDragOver(e)}
                            onDragLeave={(e) => this.onDragLeave(e)}
                            className="drop-text text-center py-3 px-2 text-small"
                            ref={(el) => (this.dropText = el)}
                        >
                            {translate("Drop Here ...")}
                        </div>
                    )}
                </div>
                {/* {rowContent.length == 0 ? (
                   
                ) : null} */}

                {this.state.showRowHandlers && rowContent.length > 0 ? (
                    <DropHandles
                        rowIndex={rowIndex}
                        onDrop={this.onDrop}
                        onDragOver={this.onDragOver}
                        onDragLeave={this.onDragLeave}
                        rowId={rowId}
                        dropHandles={dropHandles}
                    />
                ) : (
                    <div style={{ visibility: "hidden" }}>
                        <DropHandles
                            rowIndex={rowIndex}
                            onDrop={this.onDrop}
                            onDragOver={(e) => this.onDragOver(e)}
                            onDragLeave={(e) => this.onDragLeave(e)}
                            rowId={rowId}
                            dropHandles={dropHandles}
                        />
                    </div>
                )}
            </div>
        );
    }
}

export default SingleRow;
